/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import * as React from 'react';
import { useGlobalState } from 'src/core/hooks/useGlobalState';
import { tryParseJson } from 'src/core/utils/base';
import { getStorage } from 'src/core/utils/getStorage';
import { LuisConstants } from 'src/core/utils/LuisConstants';

export const useAzureResourceAcknowledger = () => {
    const { rootStore } = useGlobalState();
    const storage = getStorage('localStorage');
    const [isAcknowledged, setIsAcknowledged] = React.useState(false);

    React.useEffect(
        () => setIsAcknowledged(
                tryParseJson<boolean>(storage.getData(LuisConstants.StorageKeys.LanguageStudioResourceAcknowledgeStorageKey)) ?? false
            ),
        [rootStore.azureStore.session.csAccountStore?.id]
    );

    const changeAcknowledgement = (isAck: boolean) => {
        setIsAcknowledged(isAck);
        storage.setData(LuisConstants.StorageKeys.LanguageStudioResourceAcknowledgeStorageKey, `${isAck}`);
    };

    return { isAcknowledged, changeAcknowledgement };
};
